<template>
  <div class="version">
    <div>{{ $t('version') }}</div>
    <select v-model="version" @change="updateVersion">
      <option v-for="i in versionList" :key="i" :value="i.val">{{ i.text }}</option>
    </select>
  </div>
  <h2 class="category">
    {{ category + " - " + categoryName[$i18n.locale] }}
  </h2>
  <div class="description">
    {{ categoryDesc === undefined ? '' : categoryDesc[$i18n.locale] }}
  </div>

</template>

<script>

export default {
  name: 'QuestionnaireHeader',
  props: {
    category: String,
    categoryName: Object,
    categoryDesc: Object
  },
  data() {
    return {
      seeMore: false,
      preview: "",
      version: "2024-v1",
      versionList: [{ "val": "2023-test1", "text": "2023" }, { "val": "2024-v1", "text": "2024" }]
    };
  },
  methods: {
    updateVersion(version){
      this.$emit("updateQuestions", version.target.value);
    }
  }
}
</script>

<style lang="scss">
.category {
  font-size: 2rem;
  padding-left: 1rem;
  text-align: left;
}

.description {
  text-align: left;
  padding-left: 1rem;
  width: 80%;
}
.version {
  justify-content: flex-end;
  display: flex;
  gap: 10px;
  width: 100%;
  cursor: pointer;
  padding-right: 20%;
  align-items: center;
}

.version {
  justify-content: flex-end;
  display: flex;
  gap: 10px;
  width: 100%;
  cursor: pointer;
  padding-right: 20%;
  align-items: center;
}
</style>